import { CONTACT_TYPE, OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function contactService() {
  function getContacts() {
    return http.get('/v1/contacts', OPTIONS_INTEGRATION)
  }

  function addContact(data) {
    return http.post('/v1/contacts', data, OPTIONS_INTEGRATION)
  }

  function deleteContact(data) {
    return http.delete('/v1/contacts/', { ...OPTIONS_INTEGRATION, data })
  }

  function setMainContact(idContact) {
    return http.patch(`/v1/contacts`, { contact: idContact }, OPTIONS_INTEGRATION)
  }

  function updateContact(idContact, data) {
    return http.put(`/v1/contacts/${idContact}`, data, OPTIONS_INTEGRATION)
  }

  function sendEmailConfirmation(contact) {
    return http.post('/v1/customers/email/send-confirmation', { contact }, OPTIONS_INTEGRATION)
  }

  function confirmEmail(token, contact) {
    return http.post(
      `/v1/customers/email/confirmation`,
      { token, contact, contactType: CONTACT_TYPE.EMAIL },
      OPTIONS_INTEGRATION
    )
  }

  function sendCellphoneConfirmation(contact) {
    return http.post(`/v1/customers/cellphone/send-confirmation`, { contact }, OPTIONS_INTEGRATION)
  }

  function confirmCellphone(token, contact) {
    return http.post(
      '/v1/customers/cellphone/confirmation',
      { token, contact, contactType: CONTACT_TYPE.PHONE },
      OPTIONS_INTEGRATION
    )
  }

  function getTelephony(idContract) {
    return http.get(`v1/services/telephony/${idContract}`, OPTIONS_INTEGRATION)
  }

  function togglePaidCall(idContract, data) {
    return http.put(`/v1/services/telephony/collect/call/${idContract}`, data, OPTIONS_INTEGRATION)
  }

  function getCallExtract(idRecord) {
    return http.get(`/v1/financials/call/extract/${idRecord}`, OPTIONS_INTEGRATION)
  }

  function getCallRecord(contractId) {
    return http.get(`/v1/financials/call/records`, {
      params: { contractId },
      ...OPTIONS_INTEGRATION,
    })
  }

  function getCallsHistory(contractId, dateInitial, dateFinal) {
    return http.get('/v1/services/telephony/call/history', {
      ...OPTIONS_INTEGRATION,
      params: {
        contractId,
        dateInitial,
        dateFinal,
      },
    })
  }

  function getAlreadyOpenContactUpdateModal(contractId) {
    return http.get(`v1/contact-confirmation/${contractId}`, OPTIONS_INTEGRATION)
  }

  function sendContactUpdateModalVisualization(contractId) {
    return http.post(`v1/contact-confirmation`, contractId, OPTIONS_INTEGRATION)
  }

  function createNewPhone(data) {
    return http.post('v2/contacts/phone', data, OPTIONS_INTEGRATION)
  }

  function createNewEmail(data) {
    return http.post('v2/contacts/email', data, OPTIONS_INTEGRATION)
  }

  function updatePhone(id, body) {
    return http.patch(`v2/contacts/phone/${id}`, body, OPTIONS_INTEGRATION)
  }

  function updateEmail(id, body) {
    return http.patch(`v2/contacts/email/${id}`, body, OPTIONS_INTEGRATION)
  }

  return {
    getContacts,
    addContact,
    deleteContact,
    setMainContact,
    updateContact,
    sendEmailConfirmation,
    confirmEmail,
    sendCellphoneConfirmation,
    confirmCellphone,
    getTelephony,
    togglePaidCall,
    getCallExtract,
    getCallRecord,
    getCallsHistory,
    getAlreadyOpenContactUpdateModal,
    sendContactUpdateModalVisualization,
    createNewPhone,
    createNewEmail,
    updatePhone,
    updateEmail,
  }
}
